export default __webpack_public_path__ + "static/media/Group 11029@2x.e7dc4178.png";